import React from 'react'
import PropTypes from 'prop-types'
import { Bread, Crumb } from './common/Bread'
import { Anchor } from './common/Anchor'
import Logo from './common/Logo'
import { hasPermission } from '../utils/hasPermission'
import { USER_PERMISSIONS } from '../constants'


const BuildingHeader = ({ site, building, match }) => {
  const { name: siteName, slug: siteSlug, companyName, companyLogo } = site

  return (
    <div className="BuildingHeader">
      <div className="mb3">
        <div className="mb2">
          <Bread>
            <Crumb>
              <Anchor to="/sites">Sites</Anchor>
            </Crumb>
            {siteName && (
              <Crumb>
                <Anchor to={`/sites/${siteSlug}`}>{siteName}</Anchor>
              </Crumb>
            )}
            {building.name && <Crumb>{building.name}</Crumb>}
          </Bread>
        </div>
        <div className="flex justify-center">
          <Logo companyName={companyName} companyLogo={companyLogo} />
        </div>
        <div className="flex flex-row justify-end flex-wrap items-center">
          {hasPermission(USER_PERMISSIONS.EDIT_BUILDING) && (
            <Anchor to={`${match.url}/edit`} className="mb3 mr2" button>
              Edit Building
            </Anchor>
          )}
          {hasPermission(USER_PERMISSIONS.BUILDING_EVACUATION) && (
            <>
              <Anchor
                to={`/sites/${siteSlug}/buildings/${building.id}/evacuate`}
                className="mb3 mr2"
                buttonVariant="danger"
                button
              >
                Evacuate Building
              </Anchor>
              <Anchor
                to={`/sites/${siteSlug}/buildings/${building.id}/shelter-in-place`}
                className="mb3 mr2"
                buttonVariant="warning"
                button
              >
                Shelter in Place
              </Anchor>
              <Anchor
                to={`/sites/${siteSlug}/buildings/${building.id}/disable-evac`}
                className="mb3"
                button
              >
                Turn Off Alarm
              </Anchor>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

BuildingHeader.propTypes = {
  site: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  match: PropTypes.object,
}

export default BuildingHeader
